import React from "react";
import { Page, Image, Text, View, Document, StyleSheet, Font } from '@react-pdf/renderer';
import moment from "moment";
import { getInvoiceId } from "../../helperFunctions/utils";

import LogoPNG from "../../assets/images/logo.png";


const styles = StyleSheet.create({
  page: {
    width: 870,
    height: 1245,
    paddingTop: 35,
    paddingBottom: 35,
    paddingLeft: 50,
    paddingRight: 50,
  },
  title:{
    fontFamily: 'Helvetica-Bold',
    fontSize:'11px',
    fontWeight: "bold",
  },
  address: {
    fontSize: "10px"
  },  
  taxInvoice: {
    fontSize: "14px"
  },
  logo: {
    width: 160,
    height: 110
  },
  subtitle: {
    color: "#34556f",
  },
  section:{
    flexGrow:0,
    flexDirection:'row'
  },
  table: {
    width: '100%',
    borderBottom: "1px solid #34556f"
  },
  text:{
    fontSize:'11px',
    marginBottom:'5px',
    fontFamily: 'Helvetica'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 8,
    paddingBottom: 8,
    fontSize:'10px',
  },
  header: {
    fontSize:'10px',
    backgroundColor:'#989898',
    fontFamily: 'Helvetica-Bold',
  },
  whiteColor: {
    color: "#ffffff"
  },
  flex:{
    flexGrow:0,
    flexDirection:'row',
    height:'auto',
  },
  block: {
    display: "block"
  },
  bold: {
    fontFamily: 'Helvetica-Bold',
    fontWeight: 'bold',
  },
  session1:{
    width:'60%',
  },
  session2:{
    width:'40%',
  },
  row1: {
    width: '40%',
    marginLeft:'10px',
    marginRight: "10px"
  },
  row2: {
    width: '15%',
    marginLeft:'10px',
    marginRight: "10px"
  },
  row3: {
    width: '15%',
    marginLeft:'10px',
    marginRight: "10px"
  },
  row4: {
    width: '15%',
    marginLeft:'10px',
    marginRight: "10px"
  },
  rowBig: {
    width: '70%',
  },
  rowSmall: {
    width: '30%',
  },
  rowHalf1: {
    width: '60%',
    marginLeft:'10px'
  },
  rowHalf2: {
    width: '40%',
    marginLeft:'10px'
  },
  noPdBot: {
    paddingBottom: "0px"
  },
  noBorder: {
    border: "0px"
  },
  textRight: {
    textAlign: "right"
  },
  labelText: {
    width: "60px"
  }
});

export default function({
  billing,
  setting
}) {
  const packages = billing?.package?.map((o) => {
    return {
      name: o?.package_id?.name,
      qty: o?.package_qty,
      price: o?.package_unit_price,
      discount: o?.package_discount,
      total_price: o?.package_price,
    };
  });
  const products = billing?.product?.map((o) => {
    return {
      name: o?.product_id?.name,
      qty: o?.product_qty,
      price: o?.product_unit_price,
      discount: o?.product_discount,
      total_price: o?.product_price,
    };
  });
  const treatments = billing?.treatment?.map((o) => {
    return {
      name: o?.service_id?.name,
      qty: o?.service_qty,
      price: o?.service_unit_price,
      discount: o?.service_discount,
      total_price: o?.service_price,
    };
  });
  const others = billing?.others?.map((o) => {
    return {
      name: o?.description,
      qty: 1,
      price: o?.total_price,
      discount: 0,
      total_price: o?.total_price,
    };
  });

  const getPayedAmount = () => {
    if (billing?.isPaymentInInstallment) {
      return billing?.gst - billing?.paymentRecord[billing?.paymentRecord?.length - 1]?.remaining;
    } else {
      return billing?.gst;
    }
  }

  const getRemainingAmount = () => {
    if (billing?.isPaymentInInstallment) {
      return billing?.paymentRecord[billing?.paymentRecord?.length - 1]?.remaining;
    } else {
      return 0;
    }
  }

  return (
    <Document>
      <Page break={true} style={styles.page}>
        <View style={{...styles.section, marginBottom: "30px"}}>
          <View>
            <Image src={LogoPNG} style={styles.logo} />
          </View>
          <View style={{textAlign: "right", width: "100%"}}>
            <Text style={{...styles.text, ...styles.title, marginBottom: "6px"}}>EPION CLINIC MEDICAL AESTHETICS</Text>
            <Text style={{...styles.text, ...styles.bold, fontSize: "11px", marginBottom: "6px"}}>Company UEN: {setting?.companyUEN}</Text>
            <Text style={{...styles.text, ...styles.bold, fontSize: "11px", marginBottom: "6px"}}>GST No: {setting?.companyGST}</Text>
            <Text style={{...styles.text, ...styles.address, marginBottom: "6px"}}>{setting?.companyAddress}</Text>
            <Text style={{...styles.text, ...styles.address}}>{setting?.companyContactNo} | {setting?.companyEmail}</Text>
            <Text style={{...styles.text, ...styles.address}}>{setting?.companySite}</Text>
          </View>
        </View>
        <View style={{...styles.section, marginBottom: "10px"}}>
          <View style={styles.session1}>
            <View style={styles.flex}>
              <Text style={{...styles.text, ...styles.taxInvoice, ...styles.bold}}>Tax Invoice</Text>
            </View>
            <View style={styles.flex}>
              <Text style={{...styles.text}}>To :</Text>
              <Text style={styles.text}>{` ${billing?.patient?.patientProfile?.fullName}`}</Text>
            </View>
            {
              billing?.patient?.patientProfile?.address && (
                <View style={styles.flex}>
                  <Text style={styles.text}>{`${billing?.patient?.patientProfile?.country?.name}, ${billing?.patient?.patientProfile?.address}`}</Text>
                </View>
              )
            }
          </View>
          <View style={{...styles.session2, marginTop: "25px"}}>
            <View style={styles.flex}>
              <Text style={{...styles.text, width: "70px"}}>Invoice No </Text>
              <Text style={styles.text}>: {getInvoiceId(billing?.invoiceNo)}</Text>
            </View>
            <View style={styles.flex}>
              <Text style={{...styles.text, width: "70px"}}>Invoice Date </Text>
              <Text style={styles.text}>: {billing?.date ? moment(billing?.date).format("DD/MM/YYYY") : "-"}</Text>
            </View>
            <View style={styles.flex}>
              <Text style={{...styles.text, width: "70px"}}>Account No </Text>
              <Text style={styles.text}>: {billing?.patient?.accountNumber ? billing?.patient?.accountNumber : "-"}</Text>
            </View>
          </View>
        </View>

        <View style={{marginBottom: "10px"}}>
          <Text style={{...styles.text, ...styles.bold}}>Invoice Details</Text>
          <Text style={{...styles.text}}>Doctor: Melvint AN</Text>
          <Text style={{...styles.text}}>Patient: {`${billing?.patient?.patientProfile?.fullName} ${billing?.patient?.accountNumber ?? "-"}`}</Text>
        </View>

        <View style={styles.table}>
          <View style={{
            ...styles.row, 
            ...styles.bold, 
            ...styles.header
          }}>
            <Text style={{...styles.row1}}>Description</Text>
            <Text style={{...styles.row2, ...styles.textRight}}>Unit Price</Text>
            <Text style={{...styles.row3, ...styles.textRight}}>Qty</Text>
            <Text style={{...styles.row4, ...styles.textRight}}>Discount</Text>
            <Text style={{...styles.row4, ...styles.textRight}}>Amount</Text>
          </View>
          {
            [...packages, ...products, ...treatments, ...others]?.map((item, index) => (
              <View style={styles.row} key={index}>
                <Text style={styles.row1}>{item.name}</Text>
                <Text style={{...styles.row2, ...styles.textRight}}>${item.price}</Text>
                <Text style={{...styles.row3, ...styles.textRight}}>{item.qty}</Text>
                <Text style={{...styles.row4, ...styles.textRight}}>${item.discount}</Text>
                <Text style={{...styles.row4, ...styles.textRight}}>${item.total_price}</Text>
              </View>
            ))
          }
        </View>

        <View style={styles.row}>
          <View style={styles.rowBig}>
            <Text></Text>
          </View>
          <View style={styles.rowSmall}>
            <View style={{...styles.row, ...styles.noBorder, ...styles.noPdBot}}>
              <Text style={{...styles.rowHalf1, ...styles.bold}}>Sub Total</Text>
              <Text style={{...styles.rowHalf2, ...styles.textRight, ...styles.bold}}>${billing?.totalAmount}</Text>
            </View>
            <View style={{...styles.row, ...styles.noBorder, ...styles.noPdBot}}>
              <Text style={styles.rowHalf1}>Promo</Text>
              <Text style={{...styles.rowHalf2, ...styles.textRight}}>${billing?.promo}</Text>
            </View>
            <View style={{...styles.row, ...styles.noBorder, ...styles.noPdBot}}>
              <Text style={styles.rowHalf1}>Points</Text>
              <Text style={{...styles.rowHalf2, ...styles.textRight}}>${billing?.usePoints}</Text>
            </View>
            <View style={{...styles.row, padding: "0px", marginTop: "5px", borderTop: "1px solid #ddd"}}></View>
            <View style={{...styles.row, ...styles.noBorder, ...styles.noPdBot}}>
              <Text style={{...styles.rowHalf1, ...styles.bold}}>Total</Text>
              <Text style={{...styles.rowHalf2, ...styles.textRight, ...styles.bold}}>${billing?.actualAmount}</Text>
            </View>
            <View style={{...styles.row, ...styles.noBorder, ...styles.noPdBot}}>
              <Text style={{...styles.rowHalf1, ...styles.bold}}>Total (GST)</Text>
              <Text style={{...styles.rowHalf2, ...styles.textRight, ...styles.bold}}>${billing?.gst}</Text>
            </View>
          </View>
        </View>

        <View style={{marginBottom: "10px"}}>
          <Text style={{...styles.text, ...styles.bold}}>Payment Details</Text>
        </View>

        <View style={styles.table}>
          <View style={{
            ...styles.row, 
            ...styles.bold, 
            ...styles.header
          }}>
            <Text style={{...styles.row2, width: "30%"}}>Date</Text>
            <Text style={{...styles.row1}}>Mode</Text>
            <Text style={{...styles.row3, ...styles.textRight}}>Amount</Text>
          </View>

          {
            billing?.isPaymentInInstallment ? (
              [...billing.paymentRecord]?.map((item, index) => (
                <View style={styles.row} key={index}>
                  <Text style={{...styles.row2, width: "30%"}}>{moment(item?.date).format("DD/MM/YYYY")}</Text>
                  <Text style={styles.row1}>{item.paymentMethod}</Text>
                  <Text style={{...styles.row3, ...styles.textRight}}>${item.payed}</Text>
                </View>
              ))
            ) : (
              <View style={styles.row}>
                <Text style={{...styles.row2, width: "30%"}}>{moment(billing?.date).format("DD/MM/YYYY")}</Text>
                <Text style={styles.row1}>{billing?.paymentMethod?.name}</Text>
                <Text style={{...styles.row3, ...styles.textRight}}>${billing.gst}</Text>
              </View>
            )
          }
        </View>

        <View style={styles.row}>
          <View style={styles.rowBig}>
            <Text></Text>
          </View>
          <View style={styles.rowSmall}>
            <View style={{...styles.row, ...styles.noBorder, ...styles.noPdBot}}>
              <Text style={{...styles.rowHalf1, ...styles.bold}}>Total Paid</Text>
              <Text style={{...styles.rowHalf2, ...styles.textRight, ...styles.bold}}>${getPayedAmount()}</Text>
            </View>
            <View style={{...styles.row, ...styles.noBorder, ...styles.noPdBot}}>
              <Text style={{...styles.rowHalf1, ...styles.bold}}>Remaining Amount</Text>
              <Text style={{...styles.rowHalf2, ...styles.textRight, ...styles.bold}}>${getRemainingAmount()}</Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  )
}